export default "__VITE_ASSET__Dv5CiZRr__"